// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(function () {
    $w("#repeater1").onItemReady( ($item, itemData, index) => {
        $item('#container2').onClick((event) => {
            let linkURL =itemData.url;
            wixLocation.to(linkURL);
        });
});
});
/**
*	Adds an event handler that runs when the cursor is inside the
 input element and a key is pressed.
*	 @param {$w.KeyboardEvent} event
*/
export async function inputSearch_keyPress(event) {
	var text = $w("#inputSearch").value;
    await $w("#dataset1").setFilter(wixData.filter()
        .contains("title", text)
    );
}